module.exports = {
  "zones": {
    "US/Michigan": ["z", {
      "wallclock": 167796000000,
      "format": "E%sT",
      "abbrev": "EDT",
      "offset": -18000000,
      "posix": 167814000000,
      "save": 3600000,
      "rules": "US"
    }, {
      "wallclock": 157766400000,
      "format": "EST",
      "abbrev": "EST",
      "offset": -18000000,
      "posix": 157784400000,
      "save": 0
    }, {
      "wallclock": 94694400000,
      "format": "E%sT",
      "abbrev": "EST",
      "offset": -18000000,
      "posix": 94712400000,
      "save": 0,
      "rules": "US"
    }, {
      "wallclock": -757382400000,
      "format": "E%sT",
      "abbrev": "EST",
      "offset": -18000000,
      "posix": -757364400000,
      "save": 0,
      "rules": "Detroit"
    }, {
      "wallclock": -883612800000,
      "format": "E%sT",
      "abbrev": "EST",
      "offset": -18000000,
      "posix": -883594800000,
      "save": 0,
      "rules": "US"
    }, {
      "wallclock": -1724104800000,
      "format": "EST",
      "abbrev": "EST",
      "offset": -18000000,
      "posix": -1724083200000,
      "save": 0
    }, {
      "wallclock": -2051222400000,
      "format": "CST",
      "abbrev": "CST",
      "offset": -21600000,
      "posix": -2051202469000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": -19931000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "US": [{
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 2,
      "day": [0, 8],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2007,
      "to": 1.7976931348623157e+308,
      "month": 10,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1967,
      "to": 2006,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1987,
      "to": 2006,
      "month": 3,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1976,
      "to": 1986,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1975,
      "to": 1975,
      "month": 1,
      "day": [7, 23],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1974,
      "to": 1974,
      "month": 0,
      "day": [7, 6],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1967,
      "to": 1973,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1945,
      "to": 1945,
      "month": 7,
      "day": [7, 14],
      "time": 1380,
      "clock": "posix",
      "save": 60,
      "letter": "P",
      "saved": 3600000
    }, {
      "from": 1945,
      "to": 1945,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 1,
      "day": [7, 9],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "W",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1919,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1918,
      "to": 1919,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }],
    "Detroit": [{
      "from": 1948,
      "to": 1948,
      "month": 3,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1948,
      "to": 1948,
      "month": 8,
      "day": [0, -30],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }]
  }
};